<template>
  <div class="mt-5">
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class="" v-else>
      <v-data-table
        :headers="headers"
        v-model="selected"
        dense
        :items="requestDataItem"
        :no-data-text="Nodata"
        :options.sync="pagination"
        :items-per-page="itemsPerPage"
        @update:options="getRequestCardFundPagination()"
      >
        <template v-slot:[`item.fund_details.initiated_from`]="{ item }">
          <span class="caption">{{ item.fund_details.initiated_from }}</span>
          <br />
          <span class="caption" v-if="item.load_type == 1"
            ><b>Load Cards</b></span
          >
          <span class="caption" v-if="item.load_type == 2"
            ><b>Unload Cards</b></span
          >
        </template>

        <template v-slot:top>
          <v-row class="ml-2">
            <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
              <v-select
                label="Load Type"
                outlined
                class="mt-4"
                dense
                item-text="name"
                item-value="value"
                v-model="cardtype"
                :items="cardtypes"
              ></v-select>
            </v-col>
            <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
              <v-dialog
                ref="dialogStart"
                v-model="modalStart"
                :return-value.sync="start_date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    color="primary"
                    dense
                    v-model="start_date"
                    label="From"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    class="mt-4"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="start_date"
                  scrollable
                  :max="currentDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalStart = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      setMinMaxToDate();
                      $refs.dialogStart.save(start_date);
                    "
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
              <v-dialog
                ref="dialogEnd"
                v-model="modalEnd"
                :return-value.sync="end_date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    color="primary"
                    dense
                    v-model="end_date"
                    label="To"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    class="mt-4"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="end_date"
                  scrollable
                  :max="maxEndDate"
                  :min="start_date"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalEnd = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogEnd.save(end_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
              <v-text-field
                v-model="search"
                color="primary"
                shaped
                outlined
                dense
                class="mt-4"
                clearable
                label="Search "
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="1" xl="1" md="1" sm="12" xs="12">
              <v-btn
                small
                fab
                text
                @click="getRequestCardFund"
                color="dark"
                class="elevation-0 mt-4"
              >
                <v-icon dark>mdi-filter</v-icon>
              </v-btn></v-col
            >
            <v-spacer />
          </v-row>

          <v-card-text>
            <v-row>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-text>
        </template>
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ requestDataItem.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <span class="caption"
            ><b>{{ item.name }}</b></span
          >
        </template>
        <template v-slot:[`item.dpname`]="{ item }">
          <span class="caption">{{ item.dpname }}</span>
        </template>
        <template v-slot:[`item.card_balance`]="{ item }">
          <span class="caption">{{ item.card_balance }}</span>
        </template>
        <template v-slot:[`item.department_name`]="{ item }">
          <span class="caption">{{ item.department_name }}</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span class="caption orange--text" v-if="item.status == 1">
            Pending</span
          >
          <span class="caption green--text" v-if="item.status == 2">
            Approved</span
          >
          <span class="caption red--text" v-if="item.status == 3">
            Rejected</span
          >
          <span class="caption red--text" v-if="item.status == 4">
            Declined</span
          >
          <span class="caption pink--text" v-if="item.status == 5">
            Partially Approved
          </span>
          <span class="caption blue--text" v-if="item.status == 6">
            Processing
          </span>
        </template>
        <template v-slot:[`item.requested_from`]="{ item }">
          <div v-if="item.requested_from == '1'">
            <span v-on="on" class="caption">APP </span>
          </div>
          <div v-if="item.requested_from == '2'">
            <span v-on="on" class="caption">CORPORATE </span>
          </div>
        </template>

        <template v-slot:[`item.dep_budget`]="{ item }">
          <span class="caption">{{ item.dep_budget }}</span>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <span class="caption">{{ item.amount }}</span>
        </template>
        <template v-slot:[`item.approved_fund`]="{ item }">
          <span class="caption" v-if="item.approved_fund != null"
            ><b>{{ item.approved_fund }}</b></span
          >
          <span v-else>-</span>
          <br />
          <span class="caption" v-if="item.approved_on != null">{{
            item.approved_on
          }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.comments`]="{ item }">
          <v-tooltip color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
                color="orange"
                v-if="item.comments != null"
                >mdi-message-text</v-icon
              >
              <!-- v-if="item.nymcard_status.length > 0" -->
            </template>

            <span class="">
              {{ item.comments }}
            </span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.Actions`]="{ item }">
          <v-icon
            @click="showContent(item)"
            small
            class="mr-2"
            color="primary"
            :disabled="item.status == 6"
            >mdi-eye</v-icon
          >
        </template>
      </v-data-table>

      <v-dialog v-model="showcommStatus" width="900">
        <v-card class="overflow-hidden" height="auto">
          <v-toolbar flat class="header" dense dark>
            <v-icon>mdi-format-list-bulleted-type</v-icon>
            <span class="ml-3">
              Fund Details of {{ commentsDetails.name }} - {{ LoadCards }}</span
            >
            <!-- <span v-if="loadType == 1" class="ml-3">
              Fund Details of {{ commentsDetails.name }}</span
            >

            <span v-if="loadType == 2" class="ml-3"
              >Unload Details of {{ commentsDetails.name }}</span
            > -->
            <v-spacer></v-spacer>
            <v-btn class text dark @click="showcommStatus = false">
              <v-icon color="white" small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="">
            <v-row class="mt-3">
              <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                <v-text-field
                  v-model="commentsDetails.corp_balance"
                  label="CORPORATE BALANCE"
                  class="cursor red--text"
                  rounded
                  disabled
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                <v-text-field
                  v-model="commentsDetails.opening_balance"
                  label="OLD CARD BALANCE "
                  disabled
                  class="cursor"
                  outlined
                  rounded
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                <v-text-field
                  v-model="commentsDetails.amount"
                  label="REQUESTED AMOUNT"
                  disabled
                  class="cursor"
                  outlined
                  rounded
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                <v-text-field
                  v-model="commentsDetails.approved_fund"
                  label="APPROVED AMOUNT "
                  class="cursor white--text"
                  rounded
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                <v-text-field
                  v-model="commentsDetails.closing_balance"
                  label="NEW CARD BALANCE"
                  class="cursor white--text"
                  rounded
                  readonly
                  color="primary"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mt-n7"></v-divider>
            <v-row class="mt-n3 ml-2 mr-2">
              <v-col cols="6">
                <p class="subtitle-1 mb-n4">
                  <b class="gold--text">DEPARTMENT DETAILS </b>
                </p>
                <br />

                <p class="subtitle-2 mb-n4">
                  <b class="primary--text"> NAME :</b>
                  {{ commentsDetails.department_name }}
                </p>
                <br />
                <p class="subtitle-2 mb-n4">
                  <b class="primary--text"> BUDGET :</b>
                  MYR {{ commentsDetails.department_budget }}
                </p>
                <br />
                <p class="subtitle-2 mb-n4">
                  <b class="primary--text">ALLOCATED :</b>
                  MYR {{ commentsDetails.allocated_budget }}
                </p>
                <br />
                <p class="subtitle-2 mb-n4">
                  <b class="primary--text">UNALLOCATED :</b>
                  MYR {{ commentsDetails.unallocated_budget }}
                </p>

                <br />
              </v-col>
              <v-col cols="6" v-if="urlimage.length != 0" class="mt-5">
                <v-card-actions class="mt-3">
                  <v-avatar
                    v-for="(item, i) in urlimage"
                    :key="i"
                    size="40"
                    :class="{ 'ma-3': i }"
                    tile
                  >
                    <v-icon
                      v-if="item.includes('webp' || 'WEBP')"
                      size="46"
                      color="primary"
                      @click="openImageInNewTab(item)"
                      >mdi-image</v-icon
                    >
                    <v-icon
                      v-if="item.includes('jpg' || 'JPG')"
                      size="46"
                      color="primary"
                      @click="openImageInNewTab(item)"
                      >mdi-image</v-icon
                    >
                    <v-icon
                      v-if="item.includes('jpeg' || 'JPEG')"
                      size="46"
                      color="primary"
                      @click="openImageInNewTab(item)"
                      >mdi-image</v-icon
                    >
                    <v-icon
                      v-if="item.includes('png' || 'PNG')"
                      size="46"
                      color="primary"
                      @click="openImageInNewTab(item)"
                      >mdi-image</v-icon
                    >
                    <v-icon
                      v-if="item.includes('docx' || 'doc')"
                      size="44"
                      color="blue"
                      @click="openImageInNewTab(item)"
                      >mdi-file-word</v-icon
                    >
                    <v-icon
                      v-if="item.includes('txt')"
                      size="44"
                      color="blue"
                      @click="openImageInNewTab(item)"
                      >mdi-file-document</v-icon
                    >
                    <v-icon
                      v-if="item.includes('pdf')"
                      size="44"
                      color="red"
                      @click="openImageInNewTab(item)"
                      class="ml-3"
                      >mdi-file-pdf</v-icon
                    >

                    <v-icon
                      v-if="item.includes('xls' || 'xlsx')"
                      size="44"
                      color="green"
                      @click="openImageInNewTab(item)"
                      >mdi-file-excel</v-icon
                    >
                  </v-avatar>
                </v-card-actions>
              </v-col>
            </v-row>
            <v-divider></v-divider><br />
            <v-row class="mt-n7 ml-2 mr-2">
              <v-col cols="12">
                <p class="subtitle-2 mb-n4">
                  <b class="primary--text">FUND TITLE :</b>
                  {{ commentsDetails.fund_title }}
                </p>
                <br />
                <p class="subtitle-2 mb-n4">
                  <b class="primary--text">USER BUDGET :</b>
                  MYR {{ commentsDetails.user_budget }}
                </p>
                <br />

                <p class="subtitle-2 mb-n4">
                  <b class="primary--text">USER COMMENTS :</b>
                  {{ commentsDetails.comments }}
                </p>
                <br />
              </v-col>
            </v-row>
            <v-divider></v-divider><br />

            <v-row class="mt-1 ml-2 mr-2 mb-n10">
              <v-col cols="12">
                <p class="subtitle-2 mt-n8">
                  <b class="primary--text">APPROVED BY :</b>
                  {{ commentsDetails.approved_by }}
                </p>
                <br />
                <p class="subtitle-2 mt-n8">
                  <b class="primary--text">APPROVED ON :</b>
                  {{ commentsDetails.approved_on }}
                </p>
                <br />
                <p class="subtitle-2 mt-n8">
                  <b class="primary--text">APPROVER COMMENTS :</b>
                  {{ commentsDetails.approver_comments }}
                </p>
                <br />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog class="overflow-hidden" v-model="arraylistStatus" width="600">
        <v-toolbar dark dense class="header">
          <v-icon>mdi-file-image</v-icon>
          <span class="ml-3">Receipt </span>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="arraylistStatus = false">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-carousel hide-delimiters>
            <v-carousel-item
              v-for="(item, i) in urlimage"
              :key="i"
              :src="item"
              @click="openinWindow(item)"
            ></v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>
    </v-card>
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>
<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";
import moment from "moment";

export default {
  components: { OverleyProccessg },
  data: () => ({
    checkaccessdata: {},
    cardtype: 0,
    cardtypes: [
      {
        name: "All",
        value: 0,
      },
      {
        name: "Load Cards",
        value: 1,
      },
      {
        name: "Unload Cards",
        value: 2,
      },
    ],
    overlay: false,
    aapptitle: "",
    total: "",
    arraylistStatus: false,
    ApprRejuct: false,
    showcommStatus: false,
    filtername: "",
    filterdept: "",
    requestDataItem: [],
    Nodata: "",
    selected: [],
    urlimage: [],
    search: "",
    modalEnd1: false,
    modalEnd: false,
    enddata: new Date().toISOString().substr(0, 10),
    end_data: "",
    corpdept: [],
    corporateempname: [],
    Transactionstatus: ["Approved", "Partially approved", "Rejected"],
    headers: [
      { text: "SL NO", value: "sl_no", sortable: false },

      {
        text: "CARD USER",
        value: "name",
        sortable: false,
      },
      // {
      //   text: "Proxy Number",
      //   value: "proxy",
      // },
      {
        text: "DEPARTMENT",
        value: "department_name",
        sortable: false,
      },
      {
        text: "REQUESTED FROM / LOAD TYPE",
        value: "fund_details.initiated_from",
        sortable: false,
      },
      // {
      //   text: "LOAD TYPE",
      //   value: "load_type",
      //   sortable: false,
      // },
      // {
      //   text: "CARD BALANCE(MYR)",
      //   value: "card_balance",
      //   sortable: false,
      // },
      // {
      //   text: "Dept Budget",
      //   value: "department_budget",
      // },
      {
        text: "REQUESTED AMOUNT(MYR)",
        value: "amount",
        sortable: false,
      },
      {
        text: "APPROVED AMOUNT(MYR) / ON",
        value: "approved_fund",
        sortable: false,
      },
      // {
      //   text: "REASON",
      //   value: "comments",
      //   sortable: false,
      // },
      {
        text: "STATUS",
        value: "status",
        sortable: false,
      },
      {
        text: "VIEW",
        value: "Actions",
        sortable: false,
      },
    ],
    commentsDetails: "",
    modalStart: false,
    // modalEnd: false,
    start_date: null,
    end_date: null,
    maxEndDate: null,
    currentDate: null,
    LoadCards: "",

    loadType: "",
    itemsPerPage: 15,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
  }),
  created() {
    this.checkaccess();
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);
    this.currentDate = moment().format("YYYY-MM-DD");
    this.maxEndDate = this.end_date;
  },
  methods: {
    setMinMaxToDate() {
      let tempMaxDate = moment(this.start_date, "YYYY-MM-DD")
        .add(12, "months")
        .format("YYYY-MM-DD");
      this.maxEndDate =
        this.currentDate < tempMaxDate ? this.currentDate : tempMaxDate;

      this.end_date = this.maxEndDate;
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CARDFUNDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getRequestCardFund();
      }
    },
    openinWindow(url) {
      window.open(url, "_blank");
    },
    openImageInNewTab(url) {
      //console.log("urlurl", url);
      this.urlArrry = [];

      this.urlArrry = url;
      window.open(url, "_blank");
      // this.arraylistStatus = true;
    },
    getrequestAction(value) {
      this.ApprRejuct = true;
      this.aapptitle = value;
    },
    showContent(value) {
      //    console.log(value);
      this.commentsDetails = value;
      this.showcommStatus = true;
      if (this.commentsDetails.requested_from == "2") {
        this.InitiatedFrom = "CORPORATE";
      } else {
        this.InitiatedFrom = "APP";
      }
      this.total =
        Number(this.commentsDetails.approved_fund) +
        Number(this.commentsDetails.card_balance);
      this.urlimage = this.commentsDetails.receipt_urls;
      this.LoadCards = value.load_type == 1 ? "Load Card" : "Unload Card";
    },
    async getRequestCardFundPagination() {
      if (this.requestDataItem.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        var inputData = {
          method_name: "CORPFUND",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "GETREQFUNDS",
            corp_id: this.$store.getters.get_corpid,
            status: "0",
            load_type: this.cardtype,
            from_date: this.start_date,
            to_date: this.end_date,
            search_text: this.search,
            // corp_id:"4"
          },
        };
        var responseData = await apiCall(inputData);

        this.requestDataItem = this.requestDataItem.concat(
          responseData.data.data
        );
      }
    },
    async getRequestCardFund() {
      this.overlay = true;
      var inputData = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETREQFUNDS",
          corp_id: this.$store.getters.get_corpid,
          status: "0",
          load_type: this.cardtype,
          from_date: this.start_date,
          to_date: this.end_date,
          search_text: this.search,
          // corp_id:"4"
        },
      };
      var responseData = await apiCall(inputData);
      // console.log(responseData);
      if (responseData.data.status == "00") {
        this.requestDataItem =
          responseData.data.data == null ? [] : responseData.data.data;

        this.totalCount = responseData.data.data[0].total_count;
        for (let i = 0; i < this.requestDataItem.length; i++) {
          this.requestDataItem[i].department_name =
            this.requestDataItem[i].department_details.department_name;
          this.requestDataItem[i].allocated_budget =
            this.requestDataItem[i].department_details.allocated_budget;
          this.requestDataItem[i].department_budget =
            this.requestDataItem[i].department_details.department_budget;
          this.requestDataItem[i].unallocated_budget =
            this.requestDataItem[i].department_details.unallocated_budget;
        }
      } else if (responseData.data.status == "NOREC") {
        this.requestDataItem = [];
        this.Nodata = responseData.data.status_msg;
      }
      this.overlay = false;
      //  console.log("responseData", this.requestDataItem);
    },
  },
};
</script>
